var _defs, _text, _rect, _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 567.18 396.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:8px;font-family:ProximaNova-Light, Proxima Nova;font-weight:300;}.cls-1,.cls-6{fill:#231f20;}.cls-2{fill:#812990;}.cls-3{fill:#f04e23;}.cls-4{fill:#fff;}.cls-5{fill:#6b7b84;}.cls-7,.cls-8{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-7{stroke:#fbb040;}.cls-8{stroke:#6b7b84;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0.13 394.75)"
  }, "Size: 30cm x20cm")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.13,
    y: 0.13,
    width: 566.93,
    height: 377.95
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "170.2 378.08 113.51 283.59 56.82 378.08 170.2 378.08"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0.13 0.13 56.82 0.13 170.2 189.1 56.82 378.08 0.13 378.08 0.13 0.13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58,207.53l-1.07.16a4.21,4.21,0,0,1-.53.11c-.41,0-.62-.51-1.2-.63-.14,0,0,0-.21-.07s.07,0-.27-.13c0,.37-.08.27-.08.56a2.18,2.18,0,0,0,.23,1c.11.21.15.14.14.44a1.91,1.91,0,0,0,.17,1.22,3,3,0,0,1,.42.87c.57,0,.48,0,.56.17.53,0,.18-.12.48-.17,0,0,.54.13.4-.55.4.11.21.32.47.29s.11-.19.14-.44-.1-.07.27-.25l-.08-.48c0-.56.13,0,.32.08l.23-1.69c0-.13.18-.07-.15-.55C57.91,207.5,58.12,207.51,58,207.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.19,206.1c-.06.22.13.13-.16.15l.32.72c.14-.07.1-.06.32-.07,0-.49,0-.32-.16-.56S58.4,206.15,58.19,206.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.18,205.45c-.08.33,0,0-.1.26s-.14.72.34.46C54.42,205.61,54.48,205.65,54.18,205.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48,199.78a2.83,2.83,0,0,0-1,.16c-.59.15-.33.28-.14.56a3.49,3.49,0,0,0,1.39-.2c.26-.05.28,0,.13-.28H48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.23,195.86c0-.1,0-.19-.07-.28l-.92-.33-1.93-.74c-.57-.23-1.31-.54-2-.9s-1.56-.78-2.37-1.29a5.37,5.37,0,0,1-1.94-2.2,6.94,6.94,0,0,1-.44-1.11h-.15a4.05,4.05,0,0,0-.88.12c-.28.06-.56.13-.83.21a10.35,10.35,0,0,1-2.24.42l-.29,0c-.28,0-.57,0-.85,0a6.05,6.05,0,0,1-.63,0,12.82,12.82,0,0,1-1.34-.24l-.47-.1-.37.42a1.37,1.37,0,0,1,.25.23,1.63,1.63,0,0,1,.33,1.57A2.4,2.4,0,0,1,45,193.19c-.26,0-.51,0-.76,0h-.13A2.56,2.56,0,0,1,42,191.8a1.81,1.81,0,0,1,.15-2l0-.06c.1-.17.22-.33.33-.5a5.19,5.19,0,0,0,.38-.58c.07-.14.14-.28.2-.43a2.72,2.72,0,0,1-2.3-1.74,5.4,5.4,0,0,1-.36-1.67l-.23.06-.37.09a2.89,2.89,0,0,1-.32.35,2,2,0,0,1-1.42.67,1.82,1.82,0,0,1-.56-.09h-.09a1.88,1.88,0,0,1-1.07-.33,1.36,1.36,0,0,1-.87-1.61,4.94,4.94,0,0,1,.92-2c0-.06.09-.12.11-.16a1.9,1.9,0,0,1,.56-1.13c.24-.24.49-.45.72-.65l.2-.17a3.72,3.72,0,0,1,.4-.32,2.38,2.38,0,0,1,.38-1.06,4.44,4.44,0,0,1,1.33-1.29c.27-.18.55-.33.81-.47l.41-.23.37-.22.21-.14a1.19,1.19,0,0,1,.64-.18,1.3,1.3,0,0,1,.51.11,1.27,1.27,0,0,1,.69,1.45l-.4,1.4a3.31,3.31,0,0,1-.59,1.11,10.31,10.31,0,0,1,.86.59,7.23,7.23,0,0,1,.69.64h.52l.18,0a4.55,4.55,0,0,0,1.27-.58l.18-.11A10.81,10.81,0,0,1,49,179.35a17.17,17.17,0,0,1,4.43-.63H54c.83,0,1.65,0,2.41.08a13.49,13.49,0,0,1,1.84.25A10.75,10.75,0,0,1,62.66,181a.82.82,0,0,0-.43-.61c-.24-.11-.12,0-.28-.15,0,0,0,0,0,0l-.18-.14c-.28-.18-.23.05-.34-.39l-.1.06,0,0c-.18.05-.12-.31-.28-.51s.07.15-.35-.06c-.22-.11,0,0-.13-.1s-.07,0-.16-.08l-.14,0c-.66-.27-.54-.38-.54-1-.57-.15-.23-.59-.19-1,.07-.59-.28-.66-.14-1.29-.79,0-.47-.79-.7-1.63l0-.78c0-.16,0,.07.09-.22l-.21-.11c-.76-.44-.6-.79-.83-.94l-.55.18c-.16.12,0,.08-.25.14-.53-.49-.28-1.52-.46-2.18-.07-.28-.13-.67-.5-.76a1.4,1.4,0,0,1,.23-.49c-.19-.09-.28-.07-.47-.16a2.25,2.25,0,0,0-.25-1.28c-.15-.26,0-.28-.4-.32-.09.38,0,.16-.4.32a2.28,2.28,0,0,1-.29,1.23s0,0,0,.05l-.08.09a1.69,1.69,0,0,0-.33.79h.24c0,.36,0,.15-.18.38s-.09,0,0,.39-.29.45-.25.9c0,.29.13.2.12.48s-.09.23-.07.46c0,.59.24.44,0,1s-.17,1.17-.54,1.77a6.19,6.19,0,0,0-.41.87,1.15,1.15,0,0,1-.91.35,3.38,3.38,0,0,1-.81-.4c-.15-.08-.27-.13-.34-.28s0-.11-.1-.23c-.18-.4-.72-.37-1.09-.51s-.52-.68-1.44-1l-.48-.16a3.69,3.69,0,0,1-.38-.26l-.31-.34c-.09-.08-.25-.17-.37-.27l-.34-.21c-.32-.17-.27,0-.29-.44.18-.06.38-.39.53-.6s0,0,.1-.14l.07-.18s0,0,0-.05.12-.29.17-.39c-.33-.13,0,0-.32-.09.13-.18.09-.08.16-.31.42-.2.31-.09.56,0,.48-.71.2-.26.3-.67s.33-.43.5-.68l-.3-.19c-.33-.18-.26.13-.26-.46a1.55,1.55,0,0,0-.64.48c-.09-.1-.09.17-.09-.23a1.24,1.24,0,0,1-.4.15c.24-.31.13,0,.25-.32a2.08,2.08,0,0,0-1.05.4c-.2-.14-.31-.13-.4-.4-.4,0-.1.06-.47.17a1.81,1.81,0,0,0-.65-.33v-.15c-.42,0-.7.27-1.07-.15,0,0-.18-.29-.21-.34-.29.09-.17.09-.4.24a.66.66,0,0,0-.35-.45c-.13-.08,0,0-.17-.06l-.45,0c-.06,0,.12,0-.23.07v.25c.3.07,0,0,.22.09a.13.13,0,0,1,.06,0s0,0,0,0c.23.1.26,0,.63,0a1.68,1.68,0,0,1,.16.73l-.59.2,0,0-.72.08c-.3,0-.2-.07-.32-.3l-.21.1-.2.12c-.23.18.12.07-.27.21a.72.72,0,0,1-.36,0c0,.21,0,.2-.18.45s0,.24-.39.27c0,.58.06.25.17.64l-.26.09c-.4.1-.22.1-.36.5s-.34.11-.5.85c.26.18.31.18.36.34a.63.63,0,0,1,0,.3c-.77-.06-.43,0-.71,0a3,3,0,0,0-.9-.14c0,.59,0,.19-.16.34l0,0-.11.19c0-.56.11-.17.15-.64-.67-.19-.65-.9-1.33-1s0-.16-.59-.18c-.14.3-.06.36-.32.56.08-.38,0-.12,0-.24-.29.07-.17.08-.4.24,0-.37-.09-.31-.4-.16.06.24,0,.17.24.24a.94.94,0,0,0-.17.48l-.47-.4c-.21.41,0,.27-.31.49l-.1.06c-.11.06-.13.1-.24.17.12.43.21.08.08.4-.27,0-.29.11-.48.36l0,0a.22.22,0,0,1-.06.07l-.13.12c-.12.11-.26.15-.3.4a.74.74,0,0,0,.2.46c-.17.21-.15.14-.16.48l-.35-.12c-.37-.08-.18.2-.29-.12h-.4c0,.54-.2.41-.08.65s.29.2.48.47c-.2.08-.07.06-.32,0,0,.42.1.14,0,.56-.24-.17-.11-.13-.4-.64s-.29-.18-.24-.72c-.33.09-.31.26-.47.48l-.39.41a1.43,1.43,0,0,0-.32.64c0,.23.14.36.14.78,0,0,0,.05,0,.06a.64.64,0,0,1,.21-.06c-.05.18,0,.1-.12.22l-.07.08c-.12.13,0,0-.13.11l-.13.11s0,0-.05,0l-.09.07c-.2.16-.16.18-.25.4l0,.1c-.48,1.27-.77,1.27-2.2,1.81-.27.09,0,.06-.29.08s-.21-.19-.54,0-.06.18-.32.4-.46-.13-1.22.63a.64.64,0,0,1-.49.2c-.41,0-.11-.24-.64.12,0-.43.09-.16-.15-.25-.07.26-.06.21-.27.38-.48.36-.09-.11-.79.65l-.08.08-.25.31-.07.09c-.38.43-1.19.25-1.19,1.53h-.24a6.33,6.33,0,0,1-.08-.88,1.85,1.85,0,0,0-.56,1.43c.26.1.07-.13.21.2a1.14,1.14,0,0,1-.06,1,1.23,1.23,0,0,0-.15.43v.58c0,.19.07.13.26.35s.05.29.41.7a.1.1,0,0,0,.05,0c.09.12.1.15.2.28.31.41.44.2.44,1.15h-.16a1.29,1.29,0,0,0-.89-1c0,.74.2.24.25.8-.19-.12-.08-.1-.32-.16,0,.41.07.14-.16.24.52.77,1.33,1.07,1.53,2.06.08.45.55.68.72,1.06.09.21,0,.05.13.26a2.84,2.84,0,0,0,.25.23,1.2,1.2,0,0,1,.27.7c.27,1.69,1.29,2,1.4,3.05v.6c-.06.35.05.29.13.64s-.05.47-.12.74a1.66,1.66,0,0,1-.47-.07c0,.58,0,1.1.5,1.09s.9.83,2,.64c.34-.06.92,0,1.22-.16s.36-.37.48-.5l0,0,.12-.12.07-.09.24-.14c.18,0,.48,0,.56-.28,0,0,0-.13,0-.15.12-.45.76-.44,1.17-.58l.92-.13c.07,0,.09,0,.19,0,.29,0-.09-.05.21-.05l.12,0,0,0c.28.13-.21.07.3.1.07-.17.16-.27.67-.26.34,0,.93.25,1.19-.83a.71.71,0,0,1,.15-.41c.2-.23.33-.13.65-.32,1.27-.74.78-.87,2.22-.89a4.14,4.14,0,0,0,1.53-.47c1-.37.85-.64,2.31-.64a4,4,0,0,0,.92-.13c.36-.06,1.06.5,1.33.68.46-.12.22-.33.78,0,.34.2.58.13,1,.22.1.25,0,0,0,.4.26-.06.26-.1.48,0-.07.18-.15.12-.2.3l.17.45c.2.18.35,0,.55.25s.13.34.42.71a1.23,1.23,0,0,1,.26.77s0,0,0,0h-.08l-.2.21c.48.05.35.36.78.46.16,0,0,0,.17,0s0,0,.16.07l-.05-.32c-.06-.25,0-.32.47-.87.29-.37.84-.37,1.07-.78a2,2,0,0,1,.35-.6c.2-.21.06.08.18-.23,0,.06,0,0,0,0s0,0,.07.09a1.3,1.3,0,0,1,.13.19c-.23,0-.2,0-.31.15.16.37.17.32,0,.54a2,2,0,0,0-.4,1.26c0,.47-.1.36-.55.36-.07.3-.13.23-.17.57a1.94,1.94,0,0,0,.57-.17c.34-.08.38.19.57-.23l.31-1,.16.24s0,.05,0,.06l.06.11a.08.08,0,0,1,0,0c.45.91-.29.93-.34,1.46a2.7,2.7,0,0,0,.8-.15s0,0,0,0,0,0,.05,0c.49.42,1,1,.8,1.7a.43.43,0,0,0,0,.05l0,.4a1.42,1.42,0,0,0,.34.5l.33.54c.25.27.62.15.9.47l.22.26c.24-.08.24-.18.49-.11l.17.07s0,0,.07,0c.21.06.11,0,.31.09a3.28,3.28,0,0,1,.88.63c.45,0,1.31-1.13,1.52-.31.4,0,.41-.28.73-.32l-.06.11c-.1.23-.06-.14-.1.29l.37.34.12.12.25.09a.63.63,0,0,1,.14.33.39.39,0,0,0,.24-.56c.94,0,1.21-.94,2.21-.91.65,0,1.16.23,1.63-.15l.16-.22c.12-.28,0-.36,0-.6l.42-1.16a1.59,1.59,0,0,1,.85-1c.24-.2.06-.06.08-.21v-.06l0-.21a1.65,1.65,0,0,1,.44-.76c.47-.39.27-.66,1-1.42l.46-.26.06,0,.16-.12C64.44,197,64.34,196.41,64.23,195.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29,177.23Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.73,182.36a10.15,10.15,0,0,0-.81-.8,13.14,13.14,0,0,0-1.24-.8,2.57,2.57,0,0,0-.62-.24,1,1,0,0,0-.39,0,2.66,2.66,0,0,1,.67-.75,2.43,2.43,0,0,0,.88-1.19c.14-.46.27-.93.4-1.39l0,0-.62.38c-.39.23-.79.43-1.17.67a3.19,3.19,0,0,0-1,.94,1.33,1.33,0,0,0-.19,1c0,.24-.12.24-.12.24a1.64,1.64,0,0,0-.7.42c-.29.25-.59.49-.86.76a.68.68,0,0,0-.21.43,1.45,1.45,0,0,1-.33.72,3.69,3.69,0,0,0-.71,1.51c0,.19,0,.27.25.24a.59.59,0,0,0,.65.24s.07,0,.09,0c.41.21.61.17,1-.2a1.93,1.93,0,0,0,.27-.31c.19-.29.51-.31.8-.39a2.46,2.46,0,0,0,1-.4s.22-.18.32,0a3.21,3.21,0,0,1,.39.52,2.44,2.44,0,0,1,.19.75,4.67,4.67,0,0,0,.28,1.47,1.57,1.57,0,0,0,1.83,1,3,3,0,0,1,1.58,0c.1,0,.19.08.31.13l-.6-.06a.16.16,0,0,0-.19.13c-.28.66-.55,1.33-.88,2-.21.42-.51.78-.76,1.18-.15.24-.36.51-.18.8a1.39,1.39,0,0,0,1.1.78l.82,0a1.26,1.26,0,0,0,.94-.7.46.46,0,0,0-.12-.45c-.08.21-.23.24-.41.25a1,1,0,0,0-.26.12c0-.18.17-.17.31-.22l0-.35-.1.06c-.17.23-.26.26-.53.18l-.22-.07c-.24-.08-.28-.05-.3.18,0,0,0,.1,0,.18a.48.48,0,0,1,.05-.63,13.58,13.58,0,0,1,.93-1.08A12.75,12.75,0,0,0,47.08,187a1.5,1.5,0,0,0,.17-.46.9.9,0,0,0-.43-1,10.08,10.08,0,0,0-1.14-.68.77.77,0,0,1-.48-.93l.09.3c.09.29.36.37.59.49s.74.36,1.09.56a1.11,1.11,0,0,1,.36,1.78q-.3.45-.57.93c-.07.11-.08.18.1.22.64.11,1.27.29,1.92.36a9.28,9.28,0,0,0,1.58,0,16.67,16.67,0,0,0,2.87-.61,4.36,4.36,0,0,1,1.69-.1.22.22,0,0,0,.11,0c0-.31-.06-.61-.1-.9s0-.5-.07-.75a6,6,0,0,0-.59-2.44,3.77,3.77,0,0,0-.26-.39,1.54,1.54,0,0,1,.55.49,2.82,2.82,0,0,1,.45,1.22c.14.73.24,1.47.36,2.21a8.16,8.16,0,0,0,.67,2.31,4.17,4.17,0,0,0,1.5,1.72c.73.45,1.5.85,2.27,1.23s1.29.59,1.95.86c.82.33,1.65.63,2.47.94l1.19.43a.74.74,0,0,1,.48.46l-.65-.33,0,0a5.91,5.91,0,0,1,.19.69c.13.62.24,1.25.35,1.87s.16,1,.23,1.46c0,.27,0,.54,0,.81a1.73,1.73,0,0,0,.38,1.12,3,3,0,0,0,.26.24,8.82,8.82,0,0,1,1.39,1.71,1.47,1.47,0,0,0,.48.45h.39a.23.23,0,0,0,0-.12.46.46,0,0,1,0-.61,1.61,1.61,0,0,0,.17-.43c.06-.27-.12-.45-.25-.64l-.16-.2-.32.42,0,0a.74.74,0,0,0,.11-.85,1.36,1.36,0,0,0-.53-.73,1.29,1.29,0,0,1-.63-1.08c-.09-.56-.14-1.12-.2-1.68a8.22,8.22,0,0,1-.07-1c0-.48.1-1,.13-1.42a1.05,1.05,0,0,0-.28-.77,6.54,6.54,0,0,0-1.31-1c-.82-.58-1.65-1.14-2.44-1.76a11.58,11.58,0,0,1-2.68-3.07,3.57,3.57,0,0,1-.45-1.37,2.22,2.22,0,0,1,.15-1.14,4.83,4.83,0,0,0,.27,2c.43-.11.82-.27.89-.74a3.12,3.12,0,0,0-.06-.86c0-.26.09-.41.36-.36a1.35,1.35,0,0,1,.82.63c.66,1,1.29,2,1.93,3,.39.61.77,1.22,1.17,1.81.55.79,1.09,1.58,1.67,2.35a12.66,12.66,0,0,0,1,1.17c.32.35.65.67,1,1a11.82,11.82,0,0,0,2.15,1.63,12.21,12.21,0,0,0,3.07,1.35,22.2,22.2,0,0,0,2.29.49,10.16,10.16,0,0,0,1.91.12,13.9,13.9,0,0,0,2-.25,10.88,10.88,0,0,0,3-1c.46-.23.9-.53,1.35-.81a.2.2,0,0,0,.08-.08c0-.1,0-.21,0-.31s-.19,0-.26,0a6.29,6.29,0,0,0-.71.3,14.6,14.6,0,0,1-2.57.93,13.77,13.77,0,0,1-1.79.34,14.68,14.68,0,0,1-2,0,8.24,8.24,0,0,1-3.39-1,9.58,9.58,0,0,1-2.29-1.59c-.26-.24-.52-.47-.77-.72A17.44,17.44,0,0,1,69.48,193a35,35,0,0,1-1.92-3.16c-.43-.78-.85-1.57-1.28-2.36a22.86,22.86,0,0,0-2.08-3.27,14.28,14.28,0,0,0-1.64-1.75,9.46,9.46,0,0,0-4.55-2.2,13.83,13.83,0,0,0-1.68-.23c-1-.05-1.93-.1-2.89-.07a15.57,15.57,0,0,0-4.12.57,11.15,11.15,0,0,0-2.4,1.18,5.79,5.79,0,0,1-1.63.72,2.12,2.12,0,0,1-.44,0,7.71,7.71,0,0,0-1,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M148.84,169.7h-.65v1.82h-.38V169.7h-.65v-.38h1.68Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.2,169.32v2.2h-.38V170l-.73,1.12-.72-1.12v1.56H149v-2.2h.42l.68,1.07.7-1.07Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.74,175v.71a4.83,4.83,0,0,0-1.25-.68,4.61,4.61,0,0,0-1.63-.26,5,5,0,0,0-1.9.36,4.6,4.6,0,0,0-2.84,4.32,4.6,4.6,0,0,0,.35,1.81,4.73,4.73,0,0,0,1,1.49,4.53,4.53,0,0,0,1.5,1,5,5,0,0,0,1.9.37h.19A5,5,0,0,0,90,183.8v-2.53h0a2.54,2.54,0,0,1-.87.56,3,3,0,0,1-1,.19,3.27,3.27,0,0,1-.44,0h0a3.29,3.29,0,0,1-.6-.15,2.59,2.59,0,0,1-1.65-2.35,2.41,2.41,0,0,1,.78-1.81,2.63,2.63,0,0,1,.87-.55,2.83,2.83,0,0,1,1-.2,2.63,2.63,0,0,1,1.9.75,2.39,2.39,0,0,1,.79,1.81v4.67H93V175Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.25,184.16l-5-4.8v4.8H74V171.52h2.25v4.78l5-4.76h3.17l-6.56,6.29,6.56,6.33Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.81,174.81a4.24,4.24,0,0,1,1.66.32,3.69,3.69,0,0,1,1.28.91,3.9,3.9,0,0,1,.82,1.34,4.41,4.41,0,0,1,.29,1.63v5.15h-2.24V179a1.91,1.91,0,0,0-.65-1.47,2.25,2.25,0,0,0-3.08,0,1.93,1.93,0,0,0-.64,1.47v5.15H94v-9.11h2.24v.68a4.62,4.62,0,0,1,1.14-.67A3.78,3.78,0,0,1,98.81,174.81Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.2,175.05a4.14,4.14,0,0,1,1.5-.26v2.13a2.68,2.68,0,0,0-1.9.74,2.47,2.47,0,0,0-.79,1.81v4.69h-2.24V175H128v.69A5.12,5.12,0,0,1,129.2,175.05Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.78,174.81a5.12,5.12,0,0,1,1.92.36,5,5,0,0,1,1.57,1,4.77,4.77,0,0,1,1.06,1.49,4.51,4.51,0,0,1,.38,1.83,4.45,4.45,0,0,1-.38,1.81,4.77,4.77,0,0,1-1.06,1.49,4.84,4.84,0,0,1-1.57,1,5.19,5.19,0,0,1-3.85,0,4.84,4.84,0,0,1-1.57-1,4.58,4.58,0,0,1-1.05-1.49,4.3,4.3,0,0,1-.39-1.81,4.36,4.36,0,0,1,.39-1.83,4.58,4.58,0,0,1,1.05-1.49,5,5,0,0,1,1.57-1A5.14,5.14,0,0,1,135.78,174.81Zm0,2.12a2.66,2.66,0,0,0-1.91.75,2.41,2.41,0,0,0-.78,1.81,2.59,2.59,0,0,0,1.65,2.35,3,3,0,0,0,1,.19,2.89,2.89,0,0,0,1-.19,2.49,2.49,0,0,0,.88-.56,2.38,2.38,0,0,0,.79-1.79,2.42,2.42,0,0,0-.79-1.81A2.74,2.74,0,0,0,135.78,176.93Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.27,174.81a5.12,5.12,0,0,1,1.92.36,5,5,0,0,1,1.57,1,4.77,4.77,0,0,1,1.06,1.49,4.51,4.51,0,0,1,.38,1.83,4.45,4.45,0,0,1-.38,1.81,4.77,4.77,0,0,1-1.06,1.49,4.84,4.84,0,0,1-1.57,1,5.19,5.19,0,0,1-3.85,0,5,5,0,0,1-1.57-1,4.58,4.58,0,0,1-1.05-1.49,4.3,4.3,0,0,1-.39-1.81,4.36,4.36,0,0,1,.39-1.83,4.58,4.58,0,0,1,1.05-1.49,5,5,0,0,1,3.5-1.36Zm0,2.12a2.66,2.66,0,0,0-1.91.75,2.41,2.41,0,0,0-.78,1.81,2.59,2.59,0,0,0,1.65,2.35,3,3,0,0,0,1,.19,2.89,2.89,0,0,0,1-.19,2.49,2.49,0,0,0,.88-.56,2.35,2.35,0,0,0,.79-1.79,2.39,2.39,0,0,0-.79-1.81A2.74,2.74,0,0,0,146.27,176.93Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.29,175v.71a4.83,4.83,0,0,0-1.25-.68,4.61,4.61,0,0,0-1.63-.26,5,5,0,0,0-1.9.36,4.6,4.6,0,0,0-2.84,4.32,4.6,4.6,0,0,0,.35,1.81,4.73,4.73,0,0,0,1,1.49,4.53,4.53,0,0,0,1.5,1,5,5,0,0,0,1.9.37h.19a5,5,0,0,0,1.91-.36v-2.53h0a2.54,2.54,0,0,1-.87.56,3,3,0,0,1-1,.19,3.27,3.27,0,0,1-.44,0h0a3.29,3.29,0,0,1-.6-.15,2.59,2.59,0,0,1-1.65-2.35,2.41,2.41,0,0,1,.78-1.81,2.63,2.63,0,0,1,.87-.55,2.83,2.83,0,0,1,1-.2,2.63,2.63,0,0,1,1.9.75,2.39,2.39,0,0,1,.79,1.81v4.67h2.24V175Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.42,175h0v.7a4.83,4.83,0,0,0-1.25-.68,4,4,0,0,0-.81-.2,5,5,0,0,0-1-.08,4.66,4.66,0,0,0-1.85.36,4.31,4.31,0,0,0-1.46,1,4.74,4.74,0,0,0-1,1.49,5,5,0,0,0-.33,1.83h0a4.78,4.78,0,0,0,.35,1.81,4.73,4.73,0,0,0,1,1.49,4.58,4.58,0,0,0,1.51,1,4.9,4.9,0,0,0,1.89.37h.33a5.27,5.27,0,0,0,1.78-.35v-2.53h0a2.68,2.68,0,0,1-.88.56,2.7,2.7,0,0,1-1.46.15h0a3.2,3.2,0,0,1-.61-.15,2.25,2.25,0,0,1-.86-.56,2.35,2.35,0,0,1-.79-1.8,2.42,2.42,0,0,1,.18-.94l0-.08a2.6,2.6,0,0,1,.57-.78,2.49,2.49,0,0,1,.86-.55,2.83,2.83,0,0,1,1-.2,2.67,2.67,0,0,1,1.91.75,2.79,2.79,0,0,1,.57.78l0,.08a2.47,2.47,0,0,1,.18,1V183a2.39,2.39,0,0,1-.78,1.79,2.59,2.59,0,0,1-1.91.76,2.51,2.51,0,0,1-1.34-.35l-1.63,1.52a4.75,4.75,0,0,0,1.38.71,5.2,5.2,0,0,0,3.52-.12,5.18,5.18,0,0,0,1.56-1,4.61,4.61,0,0,0,1.06-1.49,4.29,4.29,0,0,0,.38-1.81v-8h-2.24Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.64,191.87v.6H74v-3.4h2.51v.6H74.7v.86h1.54v.58H74.7v.76Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.94,188.79v3.63h-.67v-.16a1.53,1.53,0,0,1-.77.21,1.36,1.36,0,0,1,0-2.71,1.63,1.63,0,0,1,.77.2v-1.17Zm-.67,2.84v-1a1,1,0,0,0-.64-.22.75.75,0,0,0-.78.75.73.73,0,0,0,.78.75A1,1,0,0,0,80.27,191.63Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.22,189.81v2.62h-.67v-.17a1.32,1.32,0,0,1-.72.21c-.76,0-1.11-.36-1.11-1.21v-1.45h.67v1.45c0,.41.19.61.56.61a.91.91,0,0,0,.6-.21v-1.85Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.34,191.94a1.28,1.28,0,0,1-1,.53,1.35,1.35,0,1,1,0-2.7,1.26,1.26,0,0,1,1,.52l-.44.4a.68.68,0,0,0-.58-.32.75.75,0,1,0,0,1.5.69.69,0,0,0,.58-.33Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.63,189.81v2.62H93v-.19a1.42,1.42,0,0,1-.77.23,1.36,1.36,0,0,1,0-2.71A1.54,1.54,0,0,1,93,190v-.17Zm-.67.78a1,1,0,0,0-.65-.22.74.74,0,0,0-.77.74.75.75,0,0,0,.77.76,1,1,0,0,0,.65-.23Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.25,190.37v.92c0,.47.08.6.42.6l.31,0v.5a1.66,1.66,0,0,1-.61.1.76.76,0,0,1-.79-.83v-1.27h-.37v-.56h.37v-1h.67v1H97v.56Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.58,189.18a.4.4,0,0,1,.39-.4.39.39,0,0,1,.38.4.38.38,0,0,1-.38.39A.39.39,0,0,1,98.58,189.18Zm.06.67h.67v2.62h-.67Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.86,191.12a1.43,1.43,0,1,1-1.43-1.35A1.39,1.39,0,0,1,103.86,191.12Zm-.66,0a.77.77,0,0,0-1.54,0,.77.77,0,0,0,1.54,0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108,191v1.46h-.67V191c0-.41-.2-.6-.57-.6a.82.82,0,0,0-.57.2v1.86h-.67v-2.62h.67V190a1.16,1.16,0,0,1,.69-.22C107.68,189.8,108,190.16,108,191Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.28,189.67v1.21h1.63v.6h-1.63v1h-.66v-3.4h2.55v.6Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.5,191.12a1.43,1.43,0,1,1-1.43-1.35A1.39,1.39,0,0,1,119.5,191.12Zm-.66,0a.77.77,0,1,0-.77.75A.76.76,0,0,0,118.84,191.12Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.65,189.81v2.62H123v-.17a1.29,1.29,0,0,1-.71.21c-.77,0-1.12-.36-1.12-1.21v-1.45h.67v1.45c0,.41.2.61.57.61a.88.88,0,0,0,.59-.21v-1.85Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128,191v1.46h-.67V191c0-.41-.2-.6-.57-.6a.85.85,0,0,0-.58.2v1.86h-.67v-2.62h.67V190a1.19,1.19,0,0,1,.7-.22C127.6,189.8,128,190.16,128,191Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.37,188.79v3.63h-.68v-.16a1.47,1.47,0,0,1-.76.21,1.36,1.36,0,0,1,0-2.71,1.56,1.56,0,0,1,.76.2v-1.17Zm-.68,2.84v-1a1,1,0,0,0-.64-.22.76.76,0,0,0-.78.75.74.74,0,0,0,.78.75A1,1,0,0,0,131.69,191.63Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.8,189.81v2.62h-.67v-.19a1.42,1.42,0,0,1-.77.23,1.36,1.36,0,0,1,0-2.71,1.54,1.54,0,0,1,.77.22v-.17Zm-.67.78a1,1,0,0,0-.65-.22.74.74,0,0,0-.77.74.75.75,0,0,0,.77.76,1,1,0,0,0,.65-.23Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.42,190.37v.92c0,.47.08.6.42.6l.3,0v.5a1.52,1.52,0,0,1-.6.1.76.76,0,0,1-.79-.83v-1.27h-.37v-.56h.37v-1h.67v1h.73v.56Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.75,189.18a.4.4,0,0,1,.39-.4.39.39,0,0,1,.38.4.38.38,0,0,1-.38.39A.39.39,0,0,1,141.75,189.18Zm.06.67h.66v2.62h-.66Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147,191.12a1.43,1.43,0,1,1-1.43-1.35A1.39,1.39,0,0,1,147,191.12Zm-.66,0a.77.77,0,0,0-1.54,0,.77.77,0,0,0,1.54,0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.2,191v1.46h-.67V191c0-.41-.2-.6-.57-.6a.87.87,0,0,0-.58.2v1.86h-.66v-2.62h.66V190a1.21,1.21,0,0,1,.7-.22C150.85,189.8,151.2,190.16,151.2,191Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.85,198.44v.6H87.23v-3.41h2.52v.6H87.91v.87h1.54v.58H87.91v.76Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93,195.4V199h-.67v-.16a1.59,1.59,0,0,1-.76.2,1.31,1.31,0,0,1-1.33-1.36,1.3,1.3,0,0,1,1.33-1.35,1.59,1.59,0,0,1,.76.19V195.4Zm-.67,2.85v-1.06a1,1,0,0,0-.64-.22.75.75,0,0,0-.79.75.74.74,0,0,0,.79.75A1,1,0,0,0,92.28,198.25Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96,196.41V199h-.67v-.18a1.25,1.25,0,0,1-.72.22c-.77,0-1.12-.36-1.12-1.21v-1.46h.67v1.46c0,.4.2.6.57.6a.88.88,0,0,0,.6-.21v-1.85Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99,198.55a1.28,1.28,0,0,1-1,.53,1.36,1.36,0,1,1,0-2.71,1.28,1.28,0,0,1,1,.52l-.44.4A.73.73,0,0,0,98,197a.75.75,0,1,0,0,1.5.7.7,0,0,0,.59-.32Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M102.06,196.41V199h-.67v-.2a1.33,1.33,0,0,1-.77.24,1.36,1.36,0,0,1,0-2.72,1.54,1.54,0,0,1,.77.22v-.17Zm-.67.79a1,1,0,0,0-.64-.23.75.75,0,1,0,0,1.5,1,1,0,0,0,.64-.22Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.49,197v.93c0,.47.08.6.42.6l.3,0v.5a1.52,1.52,0,0,1-.6.1.76.76,0,0,1-.8-.83V197h-.37v-.56h.37v-1h.68v1h.73V197Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.62,195.74a.4.4,0,0,1,.39-.4.39.39,0,0,1,.38.4.38.38,0,0,1-.38.39A.39.39,0,0,1,104.62,195.74Zm0,.67h.68V199h-.68Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.71,197.72a1.44,1.44,0,1,1-1.44-1.35A1.4,1.4,0,0,1,108.71,197.72Zm-.66,0a.78.78,0,1,0-.78.75A.77.77,0,0,0,108.05,197.72Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.69,197.57V199H111v-1.47q0-.6-.57-.6a.88.88,0,0,0-.58.21V199h-.67v-2.63h.67v.17a1.2,1.2,0,0,1,.7-.21C111.33,196.37,111.69,196.72,111.69,197.57Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116.75,197.53a6.39,6.39,0,0,1-.52.77l.41.4-.4.38-.38-.38a1.43,1.43,0,0,1-.9.38c-.79,0-1.29-.37-1.29-1a1,1,0,0,1,.72-.92.91.91,0,0,1,.65-1.58.9.9,0,0,1,1,.85,1.05,1.05,0,0,1-.74.94l.59.55a4,4,0,0,0,.4-.56Zm-1.24.8-.76-.75c-.28.11-.41.28-.41.48s.24.48.65.48A.85.85,0,0,0,115.51,198.33Zm-.86-1.79a.66.66,0,0,0,.3.48c.21-.06.5-.22.5-.49a.41.41,0,0,0-.41-.45A.42.42,0,0,0,114.65,196.54Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.25,195.63H122L120.41,199h-.32l-1.58-3.41h.75l1,2.22Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.3,195.74a.4.4,0,0,1,.39-.4.39.39,0,0,1,.38.4.38.38,0,0,1-.38.39A.39.39,0,0,1,122.3,195.74Zm.06.67H123V199h-.67Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.76,198.33a2.11,2.11,0,0,0,.9.21c.31,0,.43-.12.43-.25s-.15-.22-.55-.31c-.57-.12-1-.3-1-.81s.39-.8,1-.8a2.53,2.53,0,0,1,1,.21l-.22.49a2.55,2.55,0,0,0-.81-.17c-.26,0-.39.09-.39.23s.16.22.58.3c.61.13,1,.34,1,.82s-.38.83-1,.83a2.41,2.41,0,0,1-1.14-.25Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.81,196.41V199h-.68v-.2a1.3,1.3,0,0,1-.76.24,1.36,1.36,0,0,1,0-2.72,1.53,1.53,0,0,1,.76.22v-.17Zm-.68.79a1,1,0,0,0-.64-.23.75.75,0,1,0,0,1.5,1,1,0,0,0,.64-.22Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133.59,198c0,.65-.53,1-1.32,1a2.61,2.61,0,0,1-1.41-.32l.25-.54a2.38,2.38,0,0,0,1.19.26c.37,0,.59-.13.59-.38s-.23-.34-.72-.45c-.7-.16-1.27-.36-1.27-1s.48-1,1.26-1a3.21,3.21,0,0,1,1.3.28l-.28.55a2.91,2.91,0,0,0-1-.23c-.35,0-.54.16-.54.37s.24.34.75.46C133.09,197.18,133.59,197.41,133.59,198Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M134.64,197.92a.71.71,0,0,0,.74.58.83.83,0,0,0,.68-.32l.43.36a1.46,1.46,0,0,1-1.18.54,1.36,1.36,0,0,1,0-2.71,1.26,1.26,0,0,1,1.27,1.4v.15Zm0-.43h1.3a.58.58,0,0,0-.63-.59A.68.68,0,0,0,134.64,197.49Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.74,196.78a1,1,0,0,1,.82-.41l.17,0v.73a2,2,0,0,0-.33,0,.62.62,0,0,0-.66.68V199h-.68v-2.63h.68Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.78,196.41,140.52,199h-.32l-1.26-2.63h.71l.71,1.49.71-1.49Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M142.12,195.74a.39.39,0,1,1,.77,0,.39.39,0,1,1-.77,0Zm0,.67h.68V199h-.68Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.79,198.55a1.26,1.26,0,0,1-1,.53,1.36,1.36,0,1,1,0-2.71,1.25,1.25,0,0,1,1,.52l-.43.4a.73.73,0,0,0-.59-.32.75.75,0,1,0,0,1.5.7.7,0,0,0,.59-.32Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M146.73,197.92a.72.72,0,0,0,.75.58.85.85,0,0,0,.68-.32l.43.36a1.5,1.5,0,0,1-1.19.54,1.36,1.36,0,0,1,0-2.71,1.26,1.26,0,0,1,1.28,1.4s0,.1,0,.15Zm0-.43H148a.59.59,0,0,0-.64-.59A.68.68,0,0,0,146.74,197.49Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149.26,198.33a2.11,2.11,0,0,0,.9.21c.31,0,.43-.12.43-.25s-.15-.22-.55-.31c-.57-.12-1-.3-1-.81s.39-.8,1-.8a2.53,2.53,0,0,1,1,.21l-.22.49a2.55,2.55,0,0,0-.81-.17c-.26,0-.39.09-.39.23s.16.22.58.3c.61.13,1,.34,1,.82s-.38.83-1,.83a2.41,2.41,0,0,1-1.14-.25Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 0.13,
    x2: 567.05,
    y2: 0.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 378.08,
    x2: 567.05,
    y2: 378.08
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 0.13,
    x2: 0.13,
    y2: 378.08
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 378.08,
    y1: 0.13,
    x2: 378.08,
    y2: 378.08
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 37.92,
    y1: 0.13,
    x2: 37.92,
    y2: 378.08
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 75.72,
    y1: 0.13,
    x2: 75.72,
    y2: 378.08
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 113.51,
    y1: 0.13,
    x2: 113.51,
    y2: 378.08
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 151.31,
    y1: 0.13,
    x2: 151.31,
    y2: 378.08
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 189.1,
    y1: 0.13,
    x2: 189.1,
    y2: 378.08
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 226.9,
    y1: 0.13,
    x2: 226.9,
    y2: 378.08
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 264.69,
    y1: 0.13,
    x2: 264.69,
    y2: 378.08
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 302.49,
    y1: 0.13,
    x2: 302.49,
    y2: 378.08
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 340.28,
    y1: 0.13,
    x2: 340.28,
    y2: 378.08
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 19.02,
    y1: 0.13,
    x2: 19.02,
    y2: 378.08
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 56.82,
    y1: 0.13,
    x2: 56.82,
    y2: 378.08
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 94.61,
    y1: 0.13,
    x2: 94.61,
    y2: 378.08
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 132.41,
    y1: 0.13,
    x2: 132.41,
    y2: 378.08
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 170.2,
    y1: 0.13,
    x2: 170.2,
    y2: 378.08
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 208,
    y1: 0.13,
    x2: 208,
    y2: 378.08
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 245.79,
    y1: 0.13,
    x2: 245.79,
    y2: 378.08
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 283.59,
    y1: 0.13,
    x2: 283.59,
    y2: 378.08
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 321.38,
    y1: 0.13,
    x2: 321.38,
    y2: 378.08
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 359.18,
    y1: 0.13,
    x2: 359.18,
    y2: 378.08
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 340.28,
    x2: 567.05,
    y2: 340.28
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 302.49,
    x2: 567.05,
    y2: 302.49
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 264.69,
    x2: 567.05,
    y2: 264.69
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 226.9,
    x2: 567.05,
    y2: 226.9
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 189.1,
    x2: 567.05,
    y2: 189.1
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 151.31,
    x2: 567.05,
    y2: 151.31
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 113.51,
    x2: 567.05,
    y2: 113.51
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 75.72,
    x2: 567.05,
    y2: 75.72
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 37.92,
    x2: 567.05,
    y2: 37.92
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 359.18,
    x2: 567.05,
    y2: 359.18
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 321.38,
    x2: 567.05,
    y2: 321.38
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 283.59,
    x2: 567.05,
    y2: 283.59
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 245.79,
    x2: 567.05,
    y2: 245.79
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 208,
    x2: 567.05,
    y2: 208
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 170.2,
    x2: 567.05,
    y2: 170.2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 132.41,
    x2: 567.05,
    y2: 132.41
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 94.61,
    x2: 567.05,
    y2: 94.61
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 56.82,
    x2: 567.05,
    y2: 56.82
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 19.02,
    x2: 567.05,
    y2: 19.02
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 415.87,
    y1: 0.13,
    x2: 415.87,
    y2: 378.08
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 453.67,
    y1: 0.13,
    x2: 453.67,
    y2: 378.08
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 491.46,
    y1: 0.13,
    x2: 491.46,
    y2: 378.08
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 529.26,
    y1: 0.13,
    x2: 529.26,
    y2: 378.08
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 567.05,
    y1: 0.13,
    x2: 567.05,
    y2: 378.08
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 396.98,
    y1: 0.13,
    x2: 396.98,
    y2: 378.08
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 434.77,
    y1: 0.13,
    x2: 434.77,
    y2: 378.08
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 472.57,
    y1: 0.13,
    x2: 472.57,
    y2: 378.08
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 510.36,
    y1: 0.13,
    x2: 510.36,
    y2: 378.08
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 548.16,
    y1: 0.13,
    x2: 548.16,
    y2: 378.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.13,
    y: 0.13,
    width: 566.93,
    height: 377.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial7);
export default __webpack_public_path__ + "static/media/guideMaterial7.1ea0a138cd877725fed5c74e8da780ca.svg";
export { ForwardRef as ReactComponent };